import { createSlice } from "@reduxjs/toolkit";

const studentSlice = createSlice({
  name: "student",
  initialState: {
    plans: null,
    grades: null,
    lengthRating: null,
    rating: null,
    ratingDetailItem: null,
    classRoom: null,
    arrayAulas: null,
    monthDate: "",
    studentPlans: [],
    editDetail: null,
    itemClass: null,
    msgSchedule: null,
    demoClass: null,
    studentPlan: null,
    allPreviousClassesStudent: [],
    allNextClassesStudent: [],
    lastSchedulesStudent: [],
    studentDashboardHeader: [],
  },
  reducers: {
    setPlans(state, { payload }) {
      state.plans = payload;
    },
    setGrades(state, { payload }) {
      state.grades = payload;
    },
    setLengthRating(state, { payload }) {
      state.lengthRating = payload;
    },
    setRating(state, { payload }) {
      state.rating = payload;
    },
    setRatingDetailItem(state, { payload }) {
      state.ratingDetailItem = payload;
    },
    setClassRoom(state, { payload }) {
      state.classRoom = payload;
    },
    setArrayAulas(state, { payload }) {
      state.arrayAulas = payload;
    },
    setMonthDate(state, { payload }) {
      state.monthDate = payload;
    },
    setStudentPlans(state, { payload }) {
      state.studentPlans = payload;
    },
    setEditDetail(state, { payload }) {
      state.editDetail = payload;
    },
    setItemClass(state, { payload }) {
      state.itemClass = payload;
    },
    setMsgSchedule(state, { payload }) {
      state.msgSchedule = payload;
    },
    setDemoClass(state, { payload }) {
      state.demoClass = payload;
    },
    setStudentPlan(state, { payload }) {
      state.studentPlan = payload;
    },
    setAllPreviousClassesStudent(state, { payload }) {
      state.allPreviousClassesStudent = payload;
    },
    setAllNextClassesStudent(state, { payload }) {
      state.allNextClassesStudent = payload;
    },
    setLastSchedulesStudent(state, { payload }) {
      state.lastSchedulesStudent = payload;
    },
    clearPreviousClassesStudent(state) {
      state.allNextClassesStudent = [];
      state.allPreviousClassesStudent = [];
      state.lastSchedulesStudent = [];
    },
    setStudentDashboardHeader(state, { payload }) {
      state.studentDashboardHeader = payload;
    },
    clearState(state) {
      state.plans = null;
      state.grades = null;
      state.lengthRating = null;
      state.rating = null;
      state.ratingDetailItem = null;
      state.classRoom = null;
      state.arrayAulas = null;
      state.monthDate = "";
      state.studentPlans = null;
      state.editDetail = null;
      state.itemClass = null;
      state.msgSchedule = null;
      state.levels = null;
      state.studentPlan = null;
      state.studentDashboardHeader = [];
    },
  },
});

export const {
  setPlans,
  setGrades,
  setLengthRating,
  setRating,
  setRatingDetailItem,
  setDemoClass,
  setClassRoom,
  setArrayAulas,
  setMonthDate,
  setStudentPlans,
  setStudentPlan,
  setEditDetail,
  setItemClass,
  setMsgSchedule,
  setAllPreviousClassesStudent,
  setAllNextClassesStudent,
  setLastSchedulesStudent,
  clearPreviousClassesStudent,
  clearState,
  setStudentDashboardHeader,
} = studentSlice.actions;

export default studentSlice.reducer;
